class Rules {
  /**
   * Get rules array for component
   * Ex: Student, Batch
   *
   * Used in forms for form fields validation
   *
   * @param {String} component Ex: Student, Batch, Login
   * @returns {Array} rules
   * @memberof Rules
   */
  getRules(component) {
    var rules = {
      Student: {
        FirstName: { isRequired: true, label: "First Name", length: 20 },
        LastName: { isRequired: true, label: "Last Name", length: 20 },
        Email: { isRequired: true, label: "Email", regex: /.+@.+/ },
        Phone: { isRequired: true, label: "Phone", regex: /^\d{10,15}$/ },
        Address: { isRequired: true, label: "Address", length: 500 },
/*         Year: { isRequired: true, label: "Year", length: 10 },
        Month: { isRequired: true, label: "Month", length: 10 },
      */ Age: {
          isRequired: true,
          label: "Age",
          length: 3
        },
        DateOfBirth: { isRequired: true, label: "Date of Birth", length: 20 },
        Gender: { isRequired: true, label: "Gender", length: 20 },
/*         Location: { isRequired: true, label: "Location", length: 200 },
         */ MothersName: {
          isRequired: true,
          label: "Mother's Name",
          length: 20
        },
        FathersName: { isRequired: true, label: "Father's Name", length: 20 },
/*         Pin: { isRequired: true, label: "Pin", length: 10 },
         */ IdType: { isRequired: true, label: "ID Type", length: 20 },
        IdNo: { isRequired: true, label: "ID No", length: 20 },
        MaritalStatus: {
          isRequired: true,
          label: "Marital Status",
          length: 20
        },
        Religion: { isRequired: true, label: "Religion", length: 20 },
        Occupation: { isRequired: true, label: "Occupation", length: 20 },
        Qualification: { isRequired: true, label: "Qualification", length: 20 },
        Category: { isRequired: true, label: "Category", length: 20 },
        DateOfEnrolment: {
          isRequired: true,
          label: "Date of Enrolment",
          length: 10
        }
      },
      Approval: {
        Name: { isRequired: true, label: "Name", length: 50 }
      },
      Batch: {
        Name: { isRequired: true, label: "Name", length: 50 }
      },
      Login: {
        user: { isRequired: true, label: "Login", regex: /.+@.+/ }
      }
    };

    return rules[component];
  }

  /**
   * Get rules specific to a component
   *
   * @param {String} component
   * @returns {Array} rules
   * @memberof Rules
   */
  getComponentRules(component) {
    var rules = this.getRules(component);
    var componentRules = {};
    var keys = Object.keys(rules);
    var self = this;
    keys.forEach(function(value) {
      var fieldRules = self.getFieldRules(rules[value], self);
      componentRules[value] = fieldRules;
      //console.log(value)
    });
    return componentRules;
  }

  /**
   * Get rules specific to a field in a form
   * Each component has multiple fields with multiple rules.
   * This gives individual rule for a field
   *
   * @param {*} fieldRuleObject
   * @param {*} context
   * @returns {Array} fieldRules
   * @memberof Rules
   */
  getFieldRules(fieldRuleObject, context) {
    var fieldRules = [];
    //console.log(fieldRuleObject)
    var self = context;
    var keys = Object.keys(fieldRuleObject);
    keys.forEach(function(fieldValue) {
      /* 
        console.log(
        "fieldValue -> " +
          fieldValue +
          " fieldKey -> " +
          fieldRuleObject[fieldValue]
      );
    */
      if (fieldValue == "isRequired" && fieldRuleObject[fieldValue] == true) {
        fieldRules.push(self.ruleRequired(fieldRuleObject.label));
      }
      if (fieldValue == "length") {
        fieldRules.push(
          self.ruleFieldLength(fieldRuleObject.label, fieldRuleObject.length)
        );
      }
      if (fieldValue == "regex") {
        fieldRules.push(
          self.ruleFieldRegex(fieldRuleObject.label, fieldRuleObject.regex)
        );
      }
    });
    //console.log(fieldRules)
    return fieldRules;
  }

  /**
   * Required rule
   *
   * @param {String} field
   * @returns {Function} required validation rule
   * @memberof Rules
   */
  ruleRequired(field) {
    return v => !!v || field + " is required";
  }

  /**
   * Length rule
   *
   * @param {String} field
   * @param {Number} length
   * @returns {Function} length validation rule
   * @memberof Rules
   */
  ruleFieldLength(field, length) {
    return v =>
      (v && v.length <= length) ||
      field + " must be less than " + length + " characters";
  }

  /**
   * Regex rule
   *
   * @param {String} field
   * @param {String} regex
   * @returns {Function} regex pattern validation rule
   * @memberof Rules
   */
  ruleFieldRegex(field, regex) {
    return v => regex.test(v) || field + " must be valid";
  }
}

export default new Rules();
